export interface CommunitySwitcherDividerProps {
  readonly backgroundColor?: string;
}

export const CommunitySwitcherDivider = ({
  backgroundColor,
}: CommunitySwitcherDividerProps) => (
  <div
    className="bg-overlay-dark h-px w-9 rounded-full"
    style={backgroundColor ? { backgroundColor } : undefined}
  />
);
